import { ConnectionIndicator } from './ConnectionIndicator';
import { usePlatformEvents } from '../../contexts/PlatformEventContext';

/**
 * Page-header status dot for surfaces that listen to the platform WS.
 * Reads `isConnected` + `diagnostics` from `PlatformEventContext`
 * directly, so callers don't have to thread the values — just drop
 * `<LivePageConnectionIndicator />` next to the H1 and it lights up
 * green / red based on the shared connection.
 *
 * Same pattern used in OperatorOverview / ActivityPage / EventStreamPage,
 * codified so new pages don't reinvent the wiring.
 */
export function LivePageConnectionIndicator({ className }: { className?: string }) {
  const { isConnected, diagnostics } = usePlatformEvents();
  return (
    <ConnectionIndicator
      isConnected={isConnected}
      diagnostics={diagnostics}
      className={className}
    />
  );
}
